"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _LoadingWrapper = _interopRequireDefault(require("ecosystem-marketplace-core/components/LoadingWrapper"));

var _ReviewsList = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewsList"));

var _ReviewsListStats = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/ReviewsListStats"));

var _DetailsReviewRenderer = _interopRequireDefault(require("./DetailsReviewRenderer"));

var _urls = require("../../../utils/urls");

var _AppReviewability = _interopRequireDefault(require("../../../records/AppReviewability"));

var _WriteReviewButton = _interopRequireDefault(require("./WriteReviewButton"));

var _reviews = require("../../../selectors/reviews");

var _requestStates = require("../../../selectors/requestStates");

var _withReviewsQueryState = _interopRequireDefault(require("./withReviewsQueryState"));

var _ReviewsListEmptyState = _interopRequireDefault(require("./ReviewsListEmptyState"));

var _auth = require("../../../selectors/auth");

var textPath = 'appMarketplace.detail.reviews';

var Reviews = function Reviews(_ref) {
  var appName = _ref.appName,
      category = _ref.category,
      isPreview = _ref.isPreview,
      offeringId = _ref.offeringId,
      onWriteReviewClick = _ref.onWriteReviewClick,
      onSortChange = _ref.onSortChange,
      onFilterChange = _ref.onFilterChange,
      onPageChange = _ref.onPageChange,
      queryState = _ref.queryState,
      reviewability = _ref.reviewability,
      slug = _ref.slug;
  var isPublic = (0, _reactRedux.useSelector)(_auth.getIsPublic);
  var reviews = (0, _reactRedux.useSelector)(_reviews.getReviews);
  var reviewsFetchStatus = (0, _reactRedux.useSelector)(_requestStates.getReviewsFetchRequestState);
  var reviewStats = (0, _reactRedux.useSelector)(_reviews.getReviewStats);
  var reviewStatsFetchStatus = (0, _reactRedux.useSelector)(_requestStates.getReviewStatsRequestState);
  var reviewsCount = reviewStats.get('count');

  var renderedWriteReviewButton = _react.default.createElement(_WriteReviewButton.default, {
    disabled: isPreview,
    offeringId: offeringId,
    onClick: onWriteReviewClick,
    reviewability: reviewability
  });

  var renderedReviewsBody = (0, _react.useMemo)(function () {
    if (reviewsCount > 2) {
      return _react.default.createElement(_UIGrid.default, {
        className: "m-top-8"
      }, _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 4
        }
      }, _react.default.createElement(_ReviewsListStats.default, {
        allReviewsHref: (0, _urls.getAllReviewsUrl)(isPublic, slug, category),
        reviewStats: reviewStats,
        onFilterChange: onFilterChange
      }), _react.default.createElement(_UIFlex.default, {
        direction: "column",
        className: "p-top-5"
      }, _react.default.createElement(_H2.default, {
        className: "m-bottom-1"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: textPath + ".write.ctaTitle"
      })), _react.default.createElement(_FormattedMessage.default, {
        message: textPath + ".write.ctaDescription"
      }), _react.default.createElement("div", {
        className: "m-top-4"
      }, _react.default.createElement(_WriteReviewButton.default, {
        disabled: isPreview,
        offeringId: offeringId,
        onClick: onWriteReviewClick,
        reviewability: reviewability,
        tooltipPlacement: "right bottom"
      })))), _react.default.createElement(_UIGridItem.default, {
        size: {
          xs: 8
        }
      }, _react.default.createElement(_ReviewsList.default, {
        buttonRow: renderedWriteReviewButton,
        onSortChange: onSortChange,
        onFilterChange: onFilterChange,
        onPageChange: onPageChange,
        queryState: queryState,
        ReviewRenderer: _DetailsReviewRenderer.default,
        reviews: reviews,
        reviewStats: reviewStats
      })));
    } else if (reviewsCount && reviewsCount <= 2) {
      return _react.default.createElement(_ReviewsList.default, {
        buttonRow: renderedWriteReviewButton,
        onSortChange: onSortChange,
        onFilterChange: onFilterChange,
        onPageChange: onPageChange,
        queryState: queryState,
        ReviewRenderer: _DetailsReviewRenderer.default,
        reviews: reviews,
        reviewStats: reviewStats
      });
    } else if (!reviewsCount) {
      return _react.default.createElement(_ReviewsListEmptyState.default, {
        isPreview: isPreview,
        offeringId: offeringId,
        reviewability: reviewability,
        onWriteReviewClick: onWriteReviewClick
      });
    }

    return null;
  }, [category, isPreview, isPublic, offeringId, onFilterChange, onPageChange, onSortChange, onWriteReviewClick, queryState, renderedWriteReviewButton, reviewability, reviews, reviewStats, reviewsCount, slug]);
  return _react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, _react.default.createElement(_H.default, {
    className: "m-top-10 m-bottom-8"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.reviews.headingText",
    options: {
      name: appName
    }
  })), _react.default.createElement(_LoadingWrapper.default, {
    requestStatus: [reviewsFetchStatus, reviewStatsFetchStatus],
    showOverlay: true
  }, renderedReviewsBody));
};

Reviews.propTypes = {
  appName: _propTypes.default.string,
  category: _propTypes.default.string.isRequired,
  isPreview: _propTypes.default.bool.isRequired,
  offeringId: _propTypes.default.number.isRequired,
  onSortChange: _propTypes.default.func.isRequired,
  onFilterChange: _propTypes.default.func.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  onWriteReviewClick: _propTypes.default.func.isRequired,
  queryState: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  reviewability: _propTypes.default.instanceOf(_AppReviewability.default).isRequired,
  slug: _propTypes.default.string.isRequired
};

var _default = (0, _withReviewsQueryState.default)(Reviews);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/Reviews.js
// module id = 847
// module chunks = 209 210 211 212